import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-campaign-drag-and-drop',
  templateUrl: './campaign-drag-and-drop.component.html',
  styleUrls: ['./campaign-drag-and-drop.component.css']
})
export class CampaignDragAndDropComponent implements OnChanges, OnDestroy {
  @Input() channels: any[];
  @Input() channelPriorities: any[];
  @Input() savedPriorities: object[];

  @Output() priorityListChanged: EventEmitter<any[]> =   new EventEmitter();

  priorityList: any[] = [];
  channelsList: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['channels']) {
      this.channels.forEach(channel => this.channelsList.push(channel));
      this.priorityListChanged.emit(this.priorityList);
    }

    if (changes['savedPriorities']) {
      if (this.savedPriorities != null) {
        this.savedPriorities.forEach(sP => {
          this.priorityList.push(sP);
          this.channelsList.splice(this.channelsList.indexOf(sP), 1);
        });
      }
    }
  }

  // RxJS Subscription is an excellent API for managing many unsubscribe calls.
  // See note below about unsubscribing.
  subs = new Subscription();

  constructor(private dragulaService: DragulaService, private campaignService: Campaign2Service, private ref: ChangeDetectorRef) {

    this.subs.add(this.dragulaService.drop("CHANNELS")
      .subscribe(({ name, el, target, source, sibling }) => {
        this.priorityListChanged.emit(this.priorityList);
      })
    );

    this.subs.add(this.dragulaService.drag("CHANNELS")
    .subscribe(({ name, el, source }) => {
      this.priorityListChanged.emit(this.priorityList);
    })
  );

  }


  ngOnDestroy() {
    this.channelsList = this.channelsList.concat(this.priorityList);
    // destroy all the subscriptions at once
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-drag-and-drop/campaign-drag-and-drop.component.ts